import { createSliceSelectors } from '../utils'

// TODO : this can be broken down. One obvious
// TODO : possible slice is "registration"
// TODO : also, flattening out variables
// TODO : would help a lot with simplicity
// TODO : w visualizing/debugging data model

const TourSelectors = createSliceSelectors('tour', [
    /* tourid */ {
        namespace: 'tourid',
        selectorIn: state => state.getIn(['tours', 'current']),
    },
    /* tourError */ {
        namespace: 'tourError',
        selectorIn: state => state.get('error'),
    },

    'points',

    /* pointIndex */ {
        namespace: 'pointIndex',
        selectorIn: state => state.getIn(['points', 'current']),
    },

    /* pointsRawList */ {
        namespace: 'pointsRawList',
        selectorIn: state => state.getIn(['points', 'list']),
    },

    /* locationsList */ {
        namespace: 'locationsList',
        selectorIn: state => state.getIn(['locations', 'list']),
    },

    /* locationsIndex */ {
        namespace: 'locationsIndex',
        selectorIn: state => state.getIn(['locations', 'current']),
    },

    'actionButtons',

    /* actionButtonsVisible */ {
        namespace: 'actionButtonsVisible',
        selectorIn: state => state.getIn(['actionButtons', 'visible']),
    },

    'platform',

    'originalPlatform',

    /* toursList */ {
        namespace: 'toursList',
        selectorIn: state => state.getIn(['tours', 'list']),
    },

    'trailIndex',
    /* trailsList */ {
        namespace: 'trailsList',
        selectorIn: state => state.getIn(['trails', 'list']),
    },

    /* visited */ {
        namespace: 'visited',
        selectorIn: state => state.getIn(['stops', 'visited']),
    },

    'altMainMedia',

    /* mainMediaInitialized */ {
        namespace: 'mainMediaInitialized',
        selectorIn: state => state.getIn(['mainMedia', 'initialized']),
    },

    /* mainMediaLoadingStatus */ {
        namespace: 'mainMediaLoadingStatus',
        selectorIn: state => state.getIn(['mainMedia', 'loadingStatus']),
    },

    /* stopsList */ {
        namespace: 'stopsList',
        selectorIn: state => state.getIn(['stops', 'list']),
    },

    /* stopIndex */ {
        namespace: 'stopIndex',
        selectorIn: state => state.getIn(['stops', 'current']),
    },

    'isWindowFullScreen',

    /* isRegistrationEnabled */ {
        namespace: 'isRegistrationEnabled',
        selectorIn: state => state.getIn(['registration', 'enabled']),
    },

    'toggleDescriptionVisible',

    'welcomePrompt',

    /* regWelcomePrompt */ {
        namespace: 'regWelcomePrompt',
        selectorIn: state => state.getIn(['registration', 'welcomePrompt']),
    },

    'isAutoPlayEnabled',
    'isAutoPlayBlocked',

    /**
     * hasReachedEndOfExperience
     * Is the experience over?
     */
    {
        namespace: 'hasReachedEndOfExperience',
        selectorIn: [
            state => state.getIn(['tour', 'trails']) /* trails */,
            state => state.getIn(['tour', 'points']) /* points */,
        ],
        selectorFn: (trails, points) => {
            if (!trails || !points) return false
            const trail = trails.get('list')[trails.get('current')]
            if (trail && points.get('current') + 1 === (points.get('list')[trail.id] || []).length) {
                if (trails.get('current') + 1 < trails.get('list').length) {
                    return false
                }
                return true
            }
            return false
        },
    },

    'skippedAltMainMedia',
    'isSkipButtonVisible',

    /* tourLoading */ {
        namespace: 'tourLoading',
        selectorIn: state => state.get('loading'),
    },

    'tourHintButton',
    'client',

    /**
     * positionalMediaCanPlayOverGuide
     * For SVA they want the video guide to play over the positional media.
     * this is a hack and could lead to bad things.
     */
    {
        namespace: 'positionalMediaCanPlayOverGuide',
        selectorIn: [
            state => state.getIn(['tour', 'locations', 'list']) /* locationsList */,
            state => state.getIn(['tour', 'locations', 'current']) /* locationIndex */,
        ],
        selectorFn: (locationsList, locationIndex) => {
            const location = locationsList[locationIndex] || {}
            return location && [139912, 136683, 140543].indexOf(location.loc_id) >= 0
        },
    },

    /**
     * experienceFirstPanorama
     * Determine the first panorama content.
     */
    {
        namespace: 'experienceFirstPanorama',
        selectorIn: [
            state => state.getIn(['tour', 'locations', 'list']) /* locationsList */,
            state => state.getIn(['tour', 'locations', 'current']) /* locationIndex */,
        ],
        selectorFn: (locationsList, locationIndex) => {
            const location = locationsList[locationIndex] || {}
            return location.first_pano
        },
    },

    /* tour
     *
     */

    {
        namespace: 'tour',
        /**
         * Selector In is an array of selectors used for selector function
         */
        selectorIn: [
            /* TODO: figure out how to reference selectors I own. */
            // TourSelectors.tour.locationsList,
            // TourSelectors.tour.locationIndex,
            // TourSelectors.tour.toursList,
            // TourSelectors.tour.tourid
            state => state.getIn(['tour', 'locations', 'list']) /* locationsList */,
            state => state.getIn(['tour', 'locations', 'current']) /* locationIndex */,
            state => state.getIn(['tour', 'tours', 'list']) /* toursList */,
            state => state.getIn(['tour', 'tours', 'current']) /* tourid */,
        ],
        /**
         * Properties are ordered based on selectorIn
         */
        selectorFn: (locationsList, locationIndex, toursList, tourid) => {
            const location = locationsList[locationIndex] || {}

            return (
                toursList.find(tour => tour.tourid === tourid && tour.loc_id === location.loc_id) ||
                toursList[tourid] ||
                {}
            )
        },
    },
    /*
        registrationActionButtons
     */
    {
        namespace: 'registrationActionButtons',
        /**
         * Selector In is an array of selectors used for selector function
         */
        selectorIn: [
            state => state.getIn(['tour', 'actionButtons']) /* actionButtons */,
            state => state.getIn(['tour', 'registration', 'enabled']) /* isRegistrationEnabled */,
            state => state.getIn(['tour', 'originalPlatform']),
        ],
        selectorFn: (actionButtons, isRegistrationEnabled, originalPlatform) => {
            const enabledPlatforms = actionButtons.get('enabled_platforms') || []

            const registrationList = !isRegistrationEnabled
                ? []
                : [{ actionid: 'register', name: actionButtons.get('register').name }]

            // Only display action buttons if enabled for the current platform
            const actionButtonsList = (enabledPlatforms['actionbuttons'] || []).includes(originalPlatform)
                ? actionButtons.get('actions')
                : []

            // TODO : simplify this; a bit too fancy & can't just read
            return [...registrationList, ...actionButtonsList].reduce((buttons, prop) => {
                if (prop.actionid == 'action1' && isRegistrationEnabled) {
                    return buttons
                }
                return [...buttons, prop]
            }, [])
        },
    },
])

export default TourSelectors
